import { FC, Fragment, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import useI18n from "../../hooks/useTranslations";
import { useSystemsApi } from "../../http/useSystems";
import { getMinutesRoundedTimestamp } from "../../utils";
import ImageBorderBox from "../ui/BorderBox";
import FlexContent from "../ui/FlexContent";
import Header from "../ui/Header";
import styles from "./Home.module.css";

const Home: FC = () => {
  const i18n = useI18n();
  const navigate = useNavigate();
  const aborter = useRef(new AbortController());
  const systemApi = useSystemsApi();

  const { data, error, trigger } = systemApi.getSystems(aborter.current.signal);

  useEffect(() => {
    trigger();
  }, []);

  return (
    <>
      <Header title={i18n.translation.systems.our} path={{ display: i18n.translation.common.home }} error={error} />
      <FlexContent padding>
        <div className={styles.grid}>
          {data?.map((system) => (
            <Fragment key={system.id}>
              <ImageBorderBox
                onClick={() => navigate(`/systems/${system.id}`)}
                showIsMissing
                title={system.name}
                description={system.descriptionShort}
              >
                <div className={styles.img}>
                  {system.image ? (
                    <ImageBorderBox.Image
                      src={`${import.meta.env.VITE_BUCKET_URL}${system.image}?${getMinutesRoundedTimestamp()}`}
                    />
                  ) : (
                    ImageBorderBox.PlaceHolder
                  )}
                </div>
              </ImageBorderBox>
            </Fragment>
          ))}
        </div>
      </FlexContent>
    </>
  );
};

export default Home;
